var pug = require("!../../../../../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca class=\"profile-link\" ui-sref=\"profile({user_id: user._id})\"\u003E{{name}}\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;